module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-4-.86faa30f.jpg";